import {
    FormControlLabel,
    Checkbox,
    FormControl, MenuItem, InputLabel, Select,
    Paper,
    Table,
    Grid,
    TextField,
    InputAdornment,
    ListItemText,
} from '@mui/material';

import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import '../../../../AgGridStyle.css';
import HomeIcon from '@mui/icons-material/Home';

import { getShiftMasterdropdata, getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const Summaryreport = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Promocode Master");
    const [yojna, setYojna] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [AddRec, setAddRec] = useState("0");
    const [selectedYojnas, setSelectedYojnas] = useState([]);
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getMaxDate = () => {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 30);
        const year = maxDate.getFullYear();
        const month = String(maxDate.getMonth() + 1).padStart(2, '0');
        const day = String(maxDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const todayDate = getTodayDate();
    const maxDate = getMaxDate();

    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        Yojna: '',
        FromDate: todayDate,
        ToDate: todayDate,
    });

    const dateComparator = (filterDate, cellValue) => {
        if (cellValue == null) return -1;

        const cellDate = new Date(cellValue);
        cellDate.setHours(0, 0, 0, 0);

        const filterDateObj = new Date(filterDate);
        filterDateObj.setHours(0, 0, 0, 0);
        
        if (cellDate < filterDateObj) return -1;
        if (cellDate > filterDateObj) return 1;
        return 0;
    };

    const colDefs = useMemo(() => [
        { field: 'RowNum', headerName: 'Sr.No', width: 120 },
        {
            field: 'WrkRecvDt',
            headerName: 'Received Date',
            width: 260,
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: dateComparator,
                browserDatePicker: true,
                minValidYear: 2000,
                maxValidYear: 2030,
            },
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return date.toLocaleDateString('en-IN');
            }
        },
        { field: 'PlanedCount', headerName: 'Planed Task', width: 240 },
        { field: 'CompleteCount', headerName: 'Completed Task', width: 240 },
        { field: 'PendingCount', headerName: 'Pending Task', width: 240 },
        { 
            field: 'Ratio', 
            headerName: 'Completion Ratio', 
            width: 280,
            valueGetter: (params) => {
                if (!params.data) return '';
                const planned = params.data.PlanedCount || 0;
                const completed = params.data.CompleteCount || 0;
                
                if (planned === 0) return '0%';
                const ratio = (completed / planned) * 100;
                return `${ratio.toFixed(2)}%`;
            },
            cellStyle: (params) => {
                const value = params.value;
                if (!value) return {};
                
                const percentage = parseFloat(value);
                if (percentage >= 75) {
                    return { backgroundColor: '#e8f5e8', color: '#2e7d32', fontWeight: 'bold' };
                } else if (percentage >= 50) {
                    return { backgroundColor: '#fff3e0', color: '#f57c00', fontWeight: 'bold' };
                } else {
                    return { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' };
                }
            }
        },
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    useEffect(() => {
        fetchShiftData();
        fetchPropertyData();
    }, []);

    const fetchShiftData = async () => {
        try {
            const response = await getShiftMasterdropdata();
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.ShiftId,
                    name: item.ShiftName,
                }));
                setShiftData(dropdownItems);
                if (dropdownItems.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        Shift: dropdownItems[0].id.toString()
                    }));
                }
            }
        } catch (error) {
            toast.error("Error fetching shift data");
        }
    };

    const fetchPropertyData = async () => {
        try {
            const response = await getRoomMasterdropdata({
                Flag: "",
                UserId: UserId,
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data?.map((item) => ({
                    id: item.PropId,
                    name: item.Name,
                }));
                setPropertyData(dropdownItems);

                if (globalProperty) {
                    setFormData(prev => ({ ...prev, Property: globalProperty.toString() }));
                } else if (dropdownItems.length > 0) {
                    setFormData(prev => ({ ...prev, Property: dropdownItems[0].id.toString() }));
                }
            }
        } catch (error) {
            toast.error("Error fetching property data");
        }
    };

    const fetchReportData = async () => {
        if (!formData.Property || !formData.Shift || !formData.FromDate || !formData.ToDate) {
            toast.error('Please select all required fields');
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                PropId: parseInt(formData.Property),
                YojanaId: 1,
                ShiftId: parseInt(formData.Shift),
                HkWrkAreaId: 1,
                StrHkTaskId: "",
                StrYojanaId: selectedYojnas.length > 0 ? selectedYojnas.join(',') : "",
                StrHkWrkAreaId: "",
                WrkRecvDt: formData.FromDate,
                WrkRecvToDt: formData.ToDate,
                "Flag": "TaskRptDtSum"
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveGetTrnWrkRecvTaskDtWise',
                payload
            );

            if (response.data.Status === 0 && response.data.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    ...item,
                    RowNum: index + 1
                }));
                setRowData(formattedData);
            } else {
                setRowData([]);
                toast.info(response.data.Message || 'No data found for selected criteria');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching report data');
            setRowData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleClearFilters = () => {
        gridRef.current?.api?.setFilterModel(null);
    };

    const handleRowDoubleClick = (params) => {
        navigate("/operations/weektaskreport", {
            state: { 
                rowData: params.data,
                fromDate: formData.FromDate,
                toDate: formData.ToDate,
                propertyId: formData.Property,
                shiftId: formData.Shift
            }
        });
    };

    const onGridReady = useCallback((params) => {
    }, []);

    return (
        <Box
            sx={{
                width: '100%',
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/reports/dailysummaryreport')}
                    >
                       Report
                    </Link>
                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Summary
                    </Typography>
                </Breadcrumbs>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
                        justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
                        width: { xs: "100%", md: "auto" }
                    }}
                >
                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "150px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Property</InputLabel>
                        <Select
                            name="Property"
                            value={formData.Property}
                            onChange={handleInputChange}
                        >
                            {propertyData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "140px", md: "170px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Shift</InputLabel>
                        <Select
                            name="Shift"
                            value={formData.Shift}
                            onChange={handleInputChange}
                        >
                            {shiftData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        label="From Date"
                        type="date"
                        name="FromDate"
                        value={formData.FromDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            max: maxDate,
                            min: '2020-01-01'
                        }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <TextField
                        label="To Date"
                        type="date"
                        name="ToDate"
                        value={formData.ToDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            max: maxDate,
                            min: formData.FromDate
                        }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <Button
                        variant="contained"
                        onClick={fetchReportData}
                        disabled={isLoading}
                        sx={{
                            bgcolor: '#635bff',
                            '&:hover': { bgcolor: '#5248cc' },
                            minWidth: '80px',
                            height: '38px'
                        }}
                    >
                        {isLoading ? 'Loading..' : 'Search'}
                    </Button>

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/operations/housekeepin')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                      <Tooltip title='Next Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/operations/weektaskreport')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowForwardIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box
                className="ag-theme-alpine"
                sx={{
                    height: 'calc(100% - 100px)',
                    width: '95%',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={100}
                        paginationPageSizeSelector={[100, 1000, 5000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={25}
                        headerHeight={35}
                        onRowDoubleClicked={handleRowDoubleClick}  // Fixed: Changed from handleRowDoubleClick to onRowDoubleClicked
                        floatingFiltersHeight={30}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No data to display</span>'}
                        tooltipShowDelay={0}
                        getRowStyle={(params) => ({
                            backgroundColor: params.node.rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff',
                            cursor: 'pointer'  // Add pointer cursor to indicate clickable rows
                        })}
                    />
                )}
                {rowData.length > 0 && (
                    <Box sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 70,
                        fontSize: '14px',
                        color: 'black',
                    }}>
                        Total Records: <b>{rowData.length}</b>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Summaryreport;